var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      !_vm.mobileView
        ? _c("div", [
            _c("div", { attrs: { id: "headerImageContainer" } }, [
              _c("img", {
                staticStyle: { height: "150px" },
                attrs: { id: "headerImage", src: _vm.imageHeader }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { overflow: "auto" },
                attrs: { id: "mainContainer" }
              },
              [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "tituloSeccion",
                      attrs: { id: "labelEstado" }
                    },
                    [_vm._v("Cuenta Corriente:")]
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { id: "labelCtaCte" } }, [
                    _vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.saldoCtaCte)))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "verTodos", on: { click: _vm.btnCtaCte } },
                    [_vm._v("Ver")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "tituloSeccion",
                        attrs: { id: "labelEstado" }
                      },
                      [_vm._v("Pedidos")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "verTodos",
                        on: { click: _vm.btnVerEstadoPedidos }
                      },
                      [_vm._v("Ver Todos")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "fh cc" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "oblea-NuevoPedido",
                        on: { click: _vm.btnNuevoPedido }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "30px", height: "30px" },
                          attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                        }),
                        _vm._v(" "),
                        _c("p", { attrs: { id: "label-realizarPedido" } }, [
                          _vm._v("Nuevo Pedido")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.itemsPedido, function(item) {
                      return _c("item-pedido-home", { attrs: { item: item } })
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "promoDescLabelContainer" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showItemsPromo,
                          expression: "showItemsPromo"
                        }
                      ],
                      staticStyle: {
                        "margin-top": "20px",
                        "margin-bottom": "10px",
                        width: "425px"
                      },
                      attrs: { id: "promoLabelContainer" }
                    },
                    [
                      _c("span", { staticClass: "tituloSeccion" }, [
                        _vm._v("Combos")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "verTodos",
                          on: { click: _vm.btnVerPromociones }
                        },
                        [_vm._v("Ver Todos")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showItemsDescuento,
                          expression: "showItemsDescuento"
                        }
                      ],
                      staticStyle: {
                        "margin-top": "20px",
                        "margin-bottom": "10px"
                      },
                      attrs: { id: "descLabelContainer" }
                    },
                    [
                      _c("span", { staticClass: "tituloSeccion" }, [
                        _vm._v("Descuentos")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "verTodos",
                          on: { click: _vm.btnVerDescuentos }
                        },
                        [_vm._v("Ver Todos")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "promoDescContainer" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showItemsPromo,
                          expression: "showItemsPromo"
                        }
                      ],
                      staticStyle: {
                        width: "425px",
                        height: "150px",
                        "margin-right": "0px"
                      },
                      attrs: { id: "promoContainer" }
                    },
                    _vm._l(_vm.itemsPromo, function(item) {
                      return _c("item-promocion", { attrs: { item: item } })
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showItemsDescuento,
                          expression: "showItemsDescuento"
                        }
                      ],
                      on: { click: _vm.btnVerDescuentos }
                    },
                    _vm._l(_vm.itemsDescuento, function(item) {
                      return _c("item-descuento", { attrs: { item: item } })
                    })
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPresupuestos,
                        expression: "showPresupuestos"
                      }
                    ],
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "tituloSeccion",
                        attrs: { id: "labelEstado" }
                      },
                      [_vm._v("Presupuestos")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "verTodos",
                        on: { click: _vm.btnVerPresupuestos }
                      },
                      [_vm._v("Ver Todos")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPresupuestos,
                        expression: "showPresupuestos"
                      }
                    ],
                    staticClass: "fh cc",
                    staticStyle: { "margin-bottom": "0px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "oblea-NuevoPedido",
                        on: { click: _vm.btnNuevoPresupuesto }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "30px", height: "30px" },
                          attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                        }),
                        _vm._v(" "),
                        _c("p", { attrs: { id: "label-realizarPedido" } }, [
                          _vm._v("Nuevo Presupuesto")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.itemsPresupuesto, function(item) {
                      return _c("item-presupuesto-home", {
                        attrs: { item: item }
                      })
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDevoluciones,
                        expression: "showDevoluciones"
                      }
                    ],
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "tituloSeccion",
                        attrs: { id: "labelEstado" }
                      },
                      [_vm._v("Devoluciones")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "verTodos",
                        on: { click: _vm.btnVerDevoluciones }
                      },
                      [_vm._v("Ver Todos")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDevoluciones,
                        expression: "showDevoluciones"
                      }
                    ],
                    staticClass: "fh cc"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "oblea-NuevoPedido",
                        on: { click: _vm.btnNuevaDevolucion }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "30px", height: "30px" },
                          attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                        }),
                        _vm._v(" "),
                        _c("p", { attrs: { id: "label-realizarPedido" } }, [
                          _vm._v("Nueva Devolución")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.itemsDevolucion, function(item) {
                      return _c("item-devolucion-home", {
                        attrs: { item: item }
                      })
                    })
                  ],
                  2
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c("div", { staticClass: "fv lt", staticStyle: { width: "100vw" } }, [
            _c(
              "div",
              {
                staticClass: "fv cc",
                staticStyle: {
                  width: "100%",
                  height: "100px",
                  background: "linear-gradient(#005A9F , #1899D6)",
                  position: "fixed",
                  top: "40px"
                }
              },
              [
                _c("img", {
                  staticStyle: { height: "80%" },
                  attrs: { id: "headerImage", src: _vm.imageHeader }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fv lt",
                staticStyle: { overflow: "auto", "margin-top": "140px" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { "margin-top": "20px", "margin-left": "30px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold",
                          color: "black"
                        }
                      },
                      [_vm._v("Cuenta Corriente:")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold",
                          color: "red"
                        }
                      },
                      [
                        _vm._v(
                          "$" + _vm._s(_vm._f("formatMoney")(_vm.saldoCtaCte))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "font-weight": "bold",
                          color: "#4969B2"
                        },
                        on: { click: _vm.btnCtaCte }
                      },
                      [_vm._v("Ver")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-top": "20px", "margin-left": "30px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold",
                          color: "black"
                        }
                      },
                      [_vm._v("Pedidos")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "font-weight": "bold",
                          color: "#4969B2"
                        },
                        on: { click: _vm.btnVerEstadoPedidos }
                      },
                      [_vm._v("Ver Todos")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh lt",
                    staticStyle: {
                      "margin-left": "30px",
                      width: "80%",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "oblea-NuevoPedido",
                        staticStyle: { width: "40%", height: "90px" },
                        on: { click: _vm.btnNuevoPedido }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "30px", height: "30px" },
                          attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "font-size": "10px",
                              "margin-top": "5px"
                            }
                          },
                          [_vm._v("Nuevo Pedido")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc mobile",
                        staticStyle: {
                          width: "60%",
                          overflow: "scroll",
                          "overflow-y": "hidden"
                        }
                      },
                      _vm._l(_vm.itemsPedido, function(item) {
                        return _c("item-pedido-home", { attrs: { item: item } })
                      })
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showItemsPromo,
                        expression: "showItemsPromo"
                      }
                    ],
                    staticStyle: { "margin-top": "20px", "margin-left": "30px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold",
                          color: "black"
                        }
                      },
                      [_vm._v("Combo")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "font-weight": "bold",
                          color: "#4969B2"
                        },
                        on: { click: _vm.btnVerPromociones }
                      },
                      [_vm._v("Ver Todos")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showItemsPromo,
                        expression: "showItemsPromo"
                      }
                    ],
                    staticClass: "fh lt",
                    staticStyle: {
                      "margin-top": "10px",
                      "margin-left": "30px",
                      width: "80%",
                      "overflow-x": "auto"
                    }
                  },
                  _vm._l(_vm.itemsPromo, function(item) {
                    return _c("item-promocion", { attrs: { item: item } })
                  })
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showItemsDescuento,
                        expression: "showItemsDescuento"
                      }
                    ],
                    staticStyle: { "margin-top": "20px", "margin-left": "30px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold",
                          color: "black"
                        }
                      },
                      [_vm._v("Descuentos")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "font-weight": "bold",
                          color: "#4969B2"
                        },
                        on: { click: _vm.btnVerDescuentos }
                      },
                      [_vm._v("Ver Todos")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showItemsDescuento,
                        expression: "showItemsDescuento"
                      }
                    ],
                    staticClass: "fh lt",
                    staticStyle: {
                      "margin-top": "10px",
                      "margin-left": "30px",
                      width: "80%",
                      "overflow-x": "auto"
                    }
                  },
                  _vm._l(_vm.itemsDescuento, function(item) {
                    return _c("item-descuento", { attrs: { item: item } })
                  })
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPresupuestos,
                        expression: "showPresupuestos"
                      }
                    ],
                    staticStyle: { "margin-top": "20px", "margin-left": "30px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold",
                          color: "black"
                        }
                      },
                      [_vm._v("Presupuestos")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "font-weight": "bold",
                          color: "#4969B2"
                        },
                        on: { click: _vm.btnVerPresupuestos }
                      },
                      [_vm._v("Ver Todos")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPresupuestos,
                        expression: "showPresupuestos"
                      }
                    ],
                    staticClass: "fh lt",
                    staticStyle: {
                      "margin-left": "30px",
                      width: "80%",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "oblea-NuevoPedido",
                        staticStyle: { width: "40%", height: "90px" },
                        on: { click: _vm.btnNuevoPresupuesto }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "30px", height: "30px" },
                          attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "font-size": "10px",
                              "margin-top": "5px"
                            }
                          },
                          [_vm._v("Nuevo Presupuesto")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc mobile",
                        staticStyle: {
                          width: "60%",
                          overflow: "scroll",
                          "overflow-y": "hidden"
                        }
                      },
                      _vm._l(_vm.itemsPresupuesto, function(item) {
                        return _c("item-presupuesto-home", {
                          attrs: { item: item }
                        })
                      })
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDevoluciones,
                        expression: "showDevoluciones"
                      }
                    ],
                    staticStyle: { "margin-top": "20px", "margin-left": "30px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "bold",
                          color: "black"
                        }
                      },
                      [_vm._v("Devoluciones")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "font-weight": "bold",
                          color: "#4969B2"
                        },
                        on: { click: _vm.btnVerDevoluciones }
                      },
                      [_vm._v("Ver Todas")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDevoluciones,
                        expression: "showDevoluciones"
                      }
                    ],
                    staticClass: "fh lt",
                    staticStyle: {
                      "margin-left": "30px",
                      width: "80%",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "oblea-NuevoPedido",
                        staticStyle: { width: "40%", height: "90px" },
                        on: { click: _vm.btnNuevaDevolucion }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "30px", height: "30px" },
                          attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "font-size": "10px",
                              "margin-top": "5px"
                            }
                          },
                          [_vm._v("Nueva Devolución")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc mobile",
                        staticStyle: {
                          width: "60%",
                          overflow: "scroll",
                          "overflow-y": "hidden"
                        }
                      },
                      _vm._l(_vm.itemsDevolucion, function(item) {
                        return _c("item-devolucion-home", {
                          attrs: { item: item }
                        })
                      })
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dd6f9e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd6f9e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/home.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3dd6f9e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/home.vue
// module chunks = 0